import pageLimits from "../../utils/page-limits";

const initialState = {};

const coinsLedger = (state = initialState, action) => {
  console.log(action.type, "action.type");
  switch (action.type) {
    case "COINS_LEDGER_REQUEST": {
      return { ...state, loading: true };
    }
    case "COINS_LEDGER_SUCCESS": {
      let items = state.records?.docs?.slice(
        0,
        pageLimits.coinsLedger * (action.payload.page - 1)
      );
      return {
        ...state,
        records:
          action.payload.page === 1
            ? action.payload
            : {
                // ...action.payload,
                page: action.payload.page,
                pages: action.payload.pages,
                docs: [...items, ...action.payload.docs],
                total: action.payload.total,
              },
        loading: false,
      };
    }
    case "COINS_LEDGER_FAILURE": {
      return { ...state, loading: false };
    }

    default:
      return state;
  }
};
export default coinsLedger;
